var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "appeal",
      style: _vm.currentIndex != 0 && !_vm.$isFlag ? "background:#fff" : ""
    },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "is-show": true,
          "title-mb": _vm.titleArray[0],
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _vm.currentIndex == 0
        ? _c("div", { staticClass: "formClass" }, [
            _c("div", { staticClass: "auth" }, [
              _c(
                "div",
                { staticClass: "name", on: { click: _vm.accountClick } },
                [
                  _c("img", {
                    attrs: {
                      src: require("assets/images/accountCenter/1099@2x.png"),
                      alt: ""
                    }
                  }),
                  _vm._m(0)
                ]
              ),
              _c("div", { staticClass: "name", on: { click: _vm.gameClick } }, [
                _c("img", {
                  attrs: {
                    src: require("assets/images/accountCenter/1100@2x.png"),
                    alt: ""
                  }
                }),
                _vm._m(1)
              ])
            ])
          ])
        : _vm.currentIndex == 1
        ? _c("div", { staticClass: "confirm" }, [
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$isFlag,
                    expression: "$isFlag"
                  }
                ],
                staticStyle: {
                  "margin-top": "0.52rem",
                  "font-size": ".34rem",
                  "font-weight": "bold",
                  "padding-left": "0.2rem",
                  "border-left": "0.1rem solid #606DE2"
                }
              },
              [_vm._v("申诉前须知")]
            ),
            _c("p", [
              _vm._v(
                " ● 请准备一个可以正常收发短信，且能正常通话的手机号码并保持畅通，用于接收申诉处理进度及工作人员必要时与您电话沟通确认账号问题【官方热线 : 0592-3011618】 "
              )
            ]),
            _c("p", [
              _vm._v(
                " ● 账号申述中心，仅限受理雷霆官方通行证账号相关问题，如各渠道账号用户，可自行联系各渠道处理【雷霆部分游戏有下发各渠道联运，渠道方账号，由各渠道方独立管理，可在各渠道版本游戏登录界面，如悬浮按钮等进入查找对应客服联系方式】 "
              )
            ]),
            _c("p", [
              _vm._v(
                " ● 温馨提示，雷霆游戏禁止一切非官方形式的私下转让，买卖账号行为，因私下（线下）转让、买卖账号导致的纠纷，请自行与对应买卖双方或者线下平台协商解决！ "
              )
            ]),
            _c(
              "div",
              { staticClass: "bottom" },
              [
                _c(
                  "van-checkbox",
                  {
                    staticClass: "checkbox",
                    model: {
                      value: _vm.checkedAppeal,
                      callback: function($$v) {
                        _vm.checkedAppeal = $$v
                      },
                      expression: "checkedAppeal"
                    }
                  },
                  [
                    _vm._v("我已阅读并同意"),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#626fdd" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.ltPassRule($event)
                          }
                        }
                      },
                      [_vm._v("《雷霆通行证服务条款》")]
                    )
                  ]
                ),
                _c(
                  "van-button",
                  {
                    staticClass: "formClass_btn",
                    attrs: {
                      round: "",
                      block: "",
                      type: "info",
                      "native-type": "submit",
                      color: "#616edf"
                    },
                    on: { click: _vm.appealClick }
                  },
                  [_vm._v("确认申诉")]
                ),
                _c("p", { on: { click: _vm.speedClick } }, [
                  _vm._v("已申诉过，查看申诉进度")
                ])
              ],
              1
            )
          ])
        : _vm.currentIndex == 2
        ? _c(
            "div",
            [
              _c(
                "van-form",
                { staticClass: "appealInfo", on: { submit: _vm.handleSubmit } },
                [
                  _c(
                    "p",
                    {
                      staticClass: "titleOne",
                      on: { click: _vm.forgetAccount }
                    },
                    [_vm._v(" 忘记账号？ ")]
                  ),
                  _c("van-field", {
                    staticStyle: { "border-radius": "16px 16px  0 0" },
                    attrs: {
                      label: "雷霆账号：",
                      rules: [{ required: true, message: "不可为空" }]
                    },
                    model: {
                      value: _vm.appealStepOne.username,
                      callback: function($$v) {
                        _vm.$set(_vm.appealStepOne, "username", $$v)
                      },
                      expression: "appealStepOne.username"
                    }
                  }),
                  _c("van-field", {
                    attrs: {
                      label: "联系手机号：",
                      rules: _vm.rules.mobileRules
                    },
                    model: {
                      value: _vm.appealStepOne.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.appealStepOne, "phone", $$v)
                      },
                      expression: "appealStepOne.phone"
                    }
                  }),
                  _c("van-field", {
                    staticStyle: { "border-radius": "0 0 16px 16px" },
                    attrs: {
                      label: "短信验证码：",
                      maxlength: "6",
                      rules: _vm.rules.codeRules
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "button",
                        fn: function() {
                          return [
                            !_vm.showTime
                              ? _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      color: "#616edf",
                                      cursor: "pointer"
                                    },
                                    on: { click: _vm.getCode }
                                  },
                                  [_vm._v(_vm._s(_vm.timeMsg))]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      color: "#878787",
                                      cursor: "pointer"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.codeTime) + " S")]
                                )
                          ]
                        },
                        proxy: true
                      }
                    ]),
                    model: {
                      value: _vm.appealStepOne.code,
                      callback: function($$v) {
                        _vm.$set(_vm.appealStepOne, "code", $$v)
                      },
                      expression: "appealStepOne.code"
                    }
                  }),
                  _c("p", { staticClass: "reg_p" }, [
                    _vm._v("*如果一分钟内没有收到验证码请重新获取")
                  ]),
                  _c("van-field", {
                    staticClass: "radio",
                    staticStyle: { "border-radius": "16px 16px 0 0" },
                    attrs: {
                      name: "radio",
                      label: "换绑设置：",
                      rules: [{ required: true, message: "不可为空" }]
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c(
                              "van-radio-group",
                              {
                                attrs: { direction: "horizontal" },
                                model: {
                                  value: _vm.appealStepOne.needResetPhone,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.appealStepOne,
                                      "needResetPhone",
                                      $$v
                                    )
                                  },
                                  expression: "appealStepOne.needResetPhone"
                                }
                              },
                              [
                                _c("van-radio", { attrs: { name: "1" } }, [
                                  _vm._v("将联系手机号作为绑定手机")
                                ]),
                                _c("van-radio", { attrs: { name: "0" } }, [
                                  _vm._v("保留原绑定手机")
                                ])
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c("van-field", {
                    attrs: {
                      label: "新密码：",
                      type: "password",
                      rules: _vm.rules.passwordRules
                    },
                    model: {
                      value: _vm.appealStepOne.password,
                      callback: function($$v) {
                        _vm.$set(_vm.appealStepOne, "password", $$v)
                      },
                      expression: "appealStepOne.password"
                    }
                  }),
                  _vm._v(" "),
                  _c("van-field", {
                    attrs: {
                      label: "确认新密码：",
                      type: "password",
                      rules: _vm.rules.passwordRules
                    },
                    model: {
                      value: _vm.appealStepOne.passwordSecond,
                      callback: function($$v) {
                        _vm.$set(_vm.appealStepOne, "passwordSecond", $$v)
                      },
                      expression: "appealStepOne.passwordSecond"
                    }
                  }),
                  _c("common-select", {
                    attrs: {
                      "selection-info": {
                        selectName: "所玩游戏：",
                        columns: _vm.columns,
                        label: "name",
                        val: "game"
                      }
                    },
                    on: { emitParentVal: _vm.emitParentVal }
                  }),
                  _c("van-field", {
                    staticClass: "radio",
                    staticStyle: { "border-radius": "0 0 16px 16px" },
                    attrs: {
                      name: "radio",
                      label: "申诉原因：",
                      rules: [{ required: true, message: "不可为空" }]
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c(
                              "van-radio-group",
                              {
                                attrs: { direction: "horizontal" },
                                model: {
                                  value: _vm.appealStepOne.appealReason,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.appealStepOne,
                                      "appealReason",
                                      $$v
                                    )
                                  },
                                  expression: "appealStepOne.appealReason"
                                }
                              },
                              [
                                _c(
                                  "van-radio",
                                  { attrs: { name: "手机号码变更" } },
                                  [_vm._v("手机号码变更")]
                                ),
                                _c(
                                  "van-radio",
                                  { attrs: { name: "账号被盗/被骗" } },
                                  [_vm._v("账号被盗/被骗")]
                                ),
                                _c("van-radio", { attrs: { name: "其他" } }, [
                                  _vm._v("其他")
                                ])
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c(
                    "div",
                    { staticClass: "bottom" },
                    [
                      _c(
                        "van-checkbox",
                        {
                          staticClass: "checkbox",
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [
                          _vm._v("我已阅读并同意 "),
                          _c(
                            "span",
                            {
                              staticStyle: { color: "#626fdd" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.ltPassRule($event)
                                }
                              }
                            },
                            [_vm._v("《雷霆通行证服务条款》")]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: { color: "#626fdd" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.ltUserRule($event)
                                }
                              }
                            },
                            [_vm._v("《雷霆游戏用户隐私政策》")]
                          )
                        ]
                      ),
                      _c(
                        "van-button",
                        {
                          staticClass: "formClass_btn",
                          attrs: {
                            round: "",
                            block: "",
                            type: "info",
                            "native-type": "submit",
                            color: "#616edf"
                          }
                        },
                        [_vm._v("下一步")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.currentIndex == 3
        ? _c(
            "div",
            { staticClass: "faceVerify" },
            [
              _vm._m(2),
              _c("canvas", { staticClass: "QR", attrs: { id: "canvas" } }),
              _c("p", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(" 请勿将二维码转发给其他人，否则可能造成损失 ")
              ]),
              _c(
                "van-button",
                {
                  staticClass: "formClass_btn",
                  attrs: {
                    round: "",
                    block: "",
                    type: "info",
                    color: "#616edf"
                  },
                  on: { click: _vm.check_face }
                },
                [_vm._v("认证已完成")]
              ),
              _vm.isShowAppealInfo
                ? _c(
                    "p",
                    {
                      staticStyle: {
                        color: "#606de2",
                        "margin-bottom": "1rem"
                      },
                      on: { click: _vm.handleAppealInfo }
                    },
                    [_vm._v("手动填写申诉信息")]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm.currentIndex == 4
        ? _c(
            "div",
            { staticClass: "applyspeed" },
            [
              _c("van-field", {
                staticStyle: { "border-radius": "16px" },
                attrs: {
                  label: "申请单号：",
                  rules: [{ required: true, message: "不可为空" }]
                },
                model: {
                  value: _vm.accountAppealNum,
                  callback: function($$v) {
                    _vm.accountAppealNum = $$v
                  },
                  expression: "accountAppealNum"
                }
              }),
              _c(
                "van-button",
                {
                  staticClass: "formClass_btn",
                  attrs: {
                    round: "",
                    block: "",
                    type: "info",
                    color: "#616edf"
                  },
                  on: { click: _vm.searchProcess }
                },
                [_vm._v("查询")]
              ),
              _c("div", [
                _vm.dealToast
                  ? _c("p", { staticClass: "stepTitle" }, [
                      _vm._v("申诉进度： "),
                      _c("span", [_vm._v(_vm._s(_vm.dealToast))])
                    ])
                  : _vm._e()
              ]),
              _vm.failReason
                ? _c("div", { staticClass: "dealReasult" }, [
                    _c("div", { staticClass: "dealFail" }, [
                      _c("p", [_vm._v("申诉失败")]),
                      _c("p", [
                        _vm._v("尊敬的雷霆用户: "),
                        _c("br"),
                        _vm._v(" 真遗憾，您提交的申诉没有通过审核。"),
                        _c("br"),
                        _vm._v(" 审核不通过理由： "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(_vm.failReason))
                        ]),
                        _c("br"),
                        _vm._v(" 我们建议您："),
                        _c("br"),
                        _vm._v(
                          " 申诉时，尽可能多地提供所记得的信息，每项信息都很重要。"
                        ),
                        _c("br"),
                        _vm._v(" 上传申请人证件请注意："),
                        _c("br"),
                        _vm._v(
                          " 1.上传清晰、有效的证件原件扫描件(工作人员会核查该证件真实性及有效日期)；"
                        ),
                        _c("br"),
                        _vm._v(
                          " 2.可用手机、相机、摄像头等进行拍摄，确保正面清晰且完整；"
                        ),
                        _c("br"),
                        _vm._v(
                          " 您可以登录雷霆游戏平台客服系统尝试重新提交申诉。"
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm.currentIndex == 5
        ? _c(
            "div",
            { staticClass: "applyFrom" },
            [
              _c(
                "van-form",
                {
                  ref: "parentFrom",
                  on: {
                    submit: _vm.appealUserInfoNextStep,
                    failed: _vm.onfailed
                  }
                },
                [
                  _c("van-field", {
                    staticClass: "realNameClass",
                    attrs: {
                      label: "姓名：",
                      name: "realName",
                      required: "",
                      rules: [{ required: true, message: "不可为空" }]
                    },
                    model: {
                      value: _vm.appealUserInfo.realName,
                      callback: function($$v) {
                        _vm.$set(_vm.appealUserInfo, "realName", $$v)
                      },
                      expression: "appealUserInfo.realName"
                    }
                  }),
                  _c("van-field", {
                    staticClass: "idCardClass",
                    attrs: {
                      label: "身份证号码：",
                      required: "",
                      name: "idCard",
                      rules: _vm.rules.idRules
                    },
                    model: {
                      value: _vm.appealUserInfo.idCard,
                      callback: function($$v) {
                        _vm.$set(_vm.appealUserInfo, "idCard", $$v)
                      },
                      expression: "appealUserInfo.idCard"
                    }
                  }),
                  _c("van-field", {
                    staticClass: "uploaderClass",
                    attrs: {
                      name: "uploader",
                      required: "",
                      label: "身份证正面："
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c(
                              "van-uploader",
                              {
                                staticClass: "uploaderFrontClass",
                                attrs: {
                                  "after-read": _vm.afterReadFront,
                                  "max-count": 1,
                                  accept: ".jpg,.jpeg,.png,",
                                  "preview-options": { closeable: true }
                                },
                                model: {
                                  value: _vm.uploaderFront,
                                  callback: function($$v) {
                                    _vm.uploaderFront = $$v
                                  },
                                  expression: "uploaderFront"
                                }
                              },
                              [
                                _vm.uploaderFront.length == 0
                                  ? _c("div", [
                                      !_vm.$isFlag
                                        ? _c(
                                            "div",
                                            { staticClass: "uploaderDiv" },
                                            [
                                              _c("p", [_vm._v("+")]),
                                              _c("p", [_vm._v("点击上传")]),
                                              _c("p", [
                                                _vm._v(
                                                  " 请勿上传虚假，模糊不清，生活照，过期证件图片， 上传此类图片无法通过申诉 "
                                                )
                                              ])
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "uploaderDiv" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "camera" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("assets/images/accountCenter/233@2x.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c("van-field", {
                    staticClass: "uploaderClass",
                    attrs: {
                      name: "uploader",
                      label: "身份证反面：",
                      required: ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c(
                              "van-uploader",
                              {
                                attrs: {
                                  "after-read": _vm.afterReadBack,
                                  accept: ".jpg,.jpeg,.png,",
                                  "max-count": 1,
                                  "preview-options": { closeable: true }
                                },
                                model: {
                                  value: _vm.uploaderBack,
                                  callback: function($$v) {
                                    _vm.uploaderBack = $$v
                                  },
                                  expression: "uploaderBack"
                                }
                              },
                              [
                                _vm.uploaderBack.length == 0
                                  ? _c("div", [
                                      !_vm.$isFlag
                                        ? _c(
                                            "div",
                                            { staticClass: "uploaderDiv" },
                                            [
                                              _c("p", [_vm._v("+")]),
                                              _c("p", [_vm._v("点击上传")]),
                                              _c("p", [
                                                _vm._v(
                                                  " 请勿上传虚假，模糊不清，生活照，过期证件图片， 上传此类图片无法通过申诉 "
                                                )
                                              ])
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "uploaderDiv" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "camera" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("assets/images/accountCenter/233@2x.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c("van-field", {
                    class: _vm.$isFlag ? "uploaderClass2" : "uploaderClass",
                    attrs: { name: "uploader", label: "上传附件：" },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function() {
                          return [
                            _c(
                              "van-uploader",
                              {
                                attrs: {
                                  "max-count": 1,
                                  accept:
                                    ".gif,.jpg,.jpeg,.png,.zip,.rar,.bmp,.pdf",
                                  "after-read": _vm.afterReadList
                                },
                                model: {
                                  value: _vm.uploaderList,
                                  callback: function($$v) {
                                    _vm.uploaderList = $$v
                                  },
                                  expression: "uploaderList"
                                }
                              },
                              [
                                !_vm.$isFlag
                                  ? _c("div", { staticClass: "uploaderDiv" }, [
                                      _c("p", [_vm._v("+")]),
                                      _c("p", [_vm._v("点击上传")]),
                                      _c("p", [
                                        _vm._v(
                                          "请将账号相关凭证信息，例如充值截图上传至附件"
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c("van-field", {
                    staticClass: "textAreaClass situationClass",
                    attrs: {
                      rows: "3",
                      autosize: "",
                      name: "situation",
                      type: "textarea",
                      maxlength: "200",
                      "show-word-limit": "",
                      required: "",
                      placeholder: "请输入您遇到的情况",
                      rules: [{ required: true, message: "不可为空" }],
                      label: "遇到情况："
                    },
                    model: {
                      value: _vm.appealUserInfo.situation,
                      callback: function($$v) {
                        _vm.$set(_vm.appealUserInfo, "situation", $$v)
                      },
                      expression: "appealUserInfo.situation"
                    }
                  }),
                  _c("van-field", {
                    attrs: { maxlength: "20", label: "区组名：" },
                    model: {
                      value: _vm.appealUserInfo.zoneName,
                      callback: function($$v) {
                        _vm.$set(_vm.appealUserInfo, "zoneName", $$v)
                      },
                      expression: "appealUserInfo.zoneName"
                    }
                  }),
                  _c("van-field", {
                    attrs: { maxlength: "50", label: "角色名：" },
                    model: {
                      value: _vm.appealUserInfo.roleName,
                      callback: function($$v) {
                        _vm.$set(_vm.appealUserInfo, "roleName", $$v)
                      },
                      expression: "appealUserInfo.roleName"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "select" },
                    [
                      _c("common-area", {
                        attrs: {
                          "selection-info": {
                            selectName: "常登录地区：",
                            key: "loginArea"
                          }
                        },
                        on: { emitAreaVal: _vm.emitAreaVal }
                      }),
                      _c("common-date", {
                        attrs: {
                          "selection-info": { selectName: "注册时间：" }
                        },
                        on: { emitTimeVal: _vm.emitTimeVal }
                      }),
                      _c("common-area", {
                        attrs: {
                          "selection-info": {
                            selectName: "注册地点：",
                            key: "regArea"
                          }
                        },
                        on: { emitAreaVal: _vm.emitAreaVal }
                      })
                    ],
                    1
                  ),
                  _c("van-field", {
                    attrs: { label: "曾用密码1：", type: "password" },
                    model: {
                      value: _vm.appealUserInfo.usedPwd1,
                      callback: function($$v) {
                        _vm.$set(_vm.appealUserInfo, "usedPwd1", $$v)
                      },
                      expression: "appealUserInfo.usedPwd1"
                    }
                  }),
                  _c("van-field", {
                    attrs: { label: "曾用密码2：", type: "password" },
                    model: {
                      value: _vm.appealUserInfo.usedPwd2,
                      callback: function($$v) {
                        _vm.$set(_vm.appealUserInfo, "usedPwd2", $$v)
                      },
                      expression: "appealUserInfo.usedPwd2"
                    }
                  }),
                  _c("van-field", {
                    attrs: { label: "曾用密码3：", type: "password" },
                    model: {
                      value: _vm.appealUserInfo.usedPwd3,
                      callback: function($$v) {
                        _vm.$set(_vm.appealUserInfo, "usedPwd3", $$v)
                      },
                      expression: "appealUserInfo.usedPwd3"
                    }
                  }),
                  _c("van-field", {
                    attrs: { maxlength: "10", label: "角色等级：" },
                    model: {
                      value: _vm.appealUserInfo.roleLevel,
                      callback: function($$v) {
                        _vm.$set(_vm.appealUserInfo, "roleLevel", $$v)
                      },
                      expression: "appealUserInfo.roleLevel"
                    }
                  }),
                  _c("van-field", {
                    staticClass: "textAreaClass",
                    staticStyle: { "border-radius": "0 0 16px 16px" },
                    attrs: {
                      rows: "3",
                      autosize: "",
                      type: "textarea",
                      maxlength: "200",
                      "show-word-limit": "",
                      label: "游戏角色描述："
                    },
                    model: {
                      value: _vm.appealUserInfo.roleDesc,
                      callback: function($$v) {
                        _vm.$set(_vm.appealUserInfo, "roleDesc", $$v)
                      },
                      expression: "appealUserInfo.roleDesc"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "bottom" },
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "formClass_btn",
                          attrs: {
                            round: "",
                            block: "",
                            type: "info",
                            color: "#616edf",
                            plain: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.currentIndex = 2
                            }
                          }
                        },
                        [_vm._v("上一步")]
                      ),
                      _c(
                        "van-button",
                        {
                          staticClass: "formClass_btn",
                          attrs: {
                            round: "",
                            block: "",
                            type: "info",
                            "native-type": "submit",
                            color: "#616edf"
                          }
                        },
                        [_vm._v("下一步")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.currentIndex == 7
        ? _c("div", { staticClass: "appealResult" }, [
            _c("img", {
              attrs: {
                src: require("assets/images/accountCenter/success@2x.png"),
                alt: ""
              }
            }),
            _c("p", [_vm._v("您的申诉已经提交成功")]),
            _c("p", [
              _vm._v("申诉单号:" + _vm._s(_vm.appealNumber) + " "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:copy",
                      value: _vm.appealNumber,
                      expression: "appealNumber",
                      arg: "copy"
                    },
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:success",
                      value: _vm.clipboardSuccess,
                      expression: "clipboardSuccess",
                      arg: "success"
                    }
                  ]
                },
                [_vm._v("复制")]
              )
            ]),
            _c("p", [
              _vm._v(
                "*申诉结果1-3个工作日将以短信的形式发送至申诉信息填写的手机号，请您注意查收。同时您可通过上方申诉单号前往账号申诉结果"
              ),
              _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      _vm.currentIndex = 4
                    }
                  }
                },
                [_vm._v("查询申诉进度")]
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("账号找回申诉")]),
      _c("p", [
        _vm._v(
          "用于绑定手机不使用/账号被骗/忘记账号名等账号信息变更相关问题申诉"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("违规处罚申诉")]),
      _c("p", [
        _vm._v(
          "针对账号或游戏被处罚有异议的反馈,包含但不限于账号或游戏的封停/禁言以及其他的处罚"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请使用"),
      _c("span", { staticStyle: { color: "#248af7" } }, [_vm._v("个人支付宝")]),
      _vm._v("，进行扫码验证")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }